/**
 * Ghost Content API client.
 * The key is intentionally public — Ghost's Content API is designed to be
 * called from the browser. Never use the Admin key here.
 */

const GHOST_URL = process.env.REACT_APP_GHOST_URL || "https://centaur-ghost.up.railway.app";
const GHOST_KEY = process.env.REACT_APP_GHOST_KEY || "a03f15d71e20a4bd4101936a68";

async function ghostFetch(path, params = {}) {
  const qs = new URLSearchParams({ key: GHOST_KEY, ...params }).toString();
  const res = await fetch(`${GHOST_URL}/ghost/api/content/${path}?${qs}`);
  if (!res.ok) {
    throw new Error(`Ghost API error: ${res.status}`);
  }
  return res.json();
}

/**
 * Fetch a list of posts.
 * @param {object} opts
 * @param {number|string} opts.limit - number of posts or "all"
 * @param {number} opts.page
 * @param {string} opts.tag - filter by tag slug
 */
export async function getPosts({ limit = "all", page = 1, tag } = {}) {
  const params = {
    limit: String(limit),
    page: String(page),
    include: "tags,authors",
  };
  if (tag) params.filter = `tag:${tag}`;
  const data = await ghostFetch("posts/", params);
  return { posts: data.posts || [], meta: data.meta };
}

/**
 * Fetch a single post by slug.
 * Returns null if not found.
 */
export async function getPost(slug) {
  const data = await ghostFetch(`posts/slug/${slug}/`, {
    include: "tags,authors",
  });
  return (data.posts || [])[0] || null;
}

/**
 * Fetch all tags that have at least one post.
 */
export async function getTags() {
  const data = await ghostFetch("tags/", {
    include: "count.posts",
    limit: "all",
  });
  return data.tags || [];
}

/**
 * Format a Ghost ISO date string to a readable locale string.
 */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
